import type { Ref } from 'vue';
import { Tracer } from '~~/lib/Tracing';
import { isValidWebAppLocale } from '~/utils/guards/isValidWebAppLocale';
import type { RelevantStoreConfig } from '~/plugins/10.shop';
import { DEFAULT_FETCH_OPTIONS } from '~/utils/defaultFetchOptions';

export function useStoreConfig(
  locale: string | undefined,
  shopStore: string | undefined
): Promise<Ref<RelevantStoreConfig | null>> {
  const tracer = new Tracer('composables');

  return tracer.withSpan(
    'useStoreConfig',
    {
      'parameter.locale': locale
    },
    async () => {
      if (
        !shopStore ||
        !locale ||
        !isValidWebAppLocale(locale) ||
        shopStore === 'china_cn'
      ) {
        return ref(null);
      }

      const data = await $fetch<RelevantStoreConfig>(
        '/api/magento/storeConfig',
        {
          ...DEFAULT_FETCH_OPTIONS,
          query: { locale, store: shopStore }
        }
      );

      if (!data) {
        throw createError('failed to load storeConfig (useStoreConfig)');
      }

      return ref(data);
    }
  );
}
